import {
    FETCH_STRAVA_ACCESS_FETCHING,
    FETCH_STRAVA_ACCESS_SUCCESS,
    FETCH_STRAVA_ACCESS_FAIL,
    FETCH_STRAVA_CONSUMER_DATA_FETCHING,
    FETCH_STRAVA_CONSUMER_DATA_SUCCESS,
    FETCH_STRAVA_CONSUMER_DATA_FAIL,
    FETCH_STRAVA_DEVICE_STATUS_FETCHING,
    FETCH_STRAVA_DEVICE_STATUS_SUCCESS,
    FETCH_STRAVA_DEVICE_STATUS_FAIL,
    UPDATE_STRAVA_ACCESS_UPDATING,
    UPDATE_STRAVA_ACCESS_SUCCESS,
    UPDATE_STRAVA_ACCESS_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    stravaAccessInfo: {},
    stravaAccessInfoFetching: null,
    stravaAccessInfoFail: null,
    stravaConsumerData: {},
    stravaConsumerDataFetching: null,
    stravaConsumerDataFail: null,
    stravaDeviceStatus: {},
    stravaDeviceStatusFetching: null,
    stravaDeviceStatusFail: null,
    stravaAccessInfoUpdating: null,
    stravaAccessInfoUpdateSucceed: null,
    stravaAccessInfoUpdateFail: null
};

// ======= Fetching Handlers =======
const fetchStravaAccessInfoFetching = (state, action) => {
    return {
        ...state,
        stravaAccessInfoFetching: true,
        stravaAccessInfoFail: false
    };
};

const fetchStravaAccessInfoSuccess = (state, action) => {
    return {
        ...state,
        stravaAccessInfo: action.stravaAccessInfo,
        stravaAccessInfoFetching: false,
        stravaAccessInfoFail: false
    };
};

const fetchStravaAccessInfoFail = (state, action) => {
    return {
        ...state,
        stravaAccessInfo: action.stravaAccessInfo,
        stravaAccessInfoFetching: false,
        stravaAccessInfoFail: true
    };
};

const fetchStravaConsumerDataFetching = (state, action) => {
    return {
        ...state,
        stravaConsumerDataFetching: true,
        stravaConsumerDataFail: false
    };
};

const fetchStravaConsumerDataSuccess = (state, action) => {
    return {
        ...state,
        stravaConsumerData: action.stravaConsumerData,
        stravaConsumerDataFetching: false,
        stravaConsumerDataFail: false
    };
};

const fetchStravaConsumerDataFail = (state, action) => {
    return {
        ...state,
        stravaConsumerData: action.stravaConsumerData,
        stravaConsumerDataFetching: false,
        stravaConsumerDataFail: true
    };
};

const fetchStravaDeviceStatusFetching = (state, action) => {
    return {
        ...state,
        stravaDeviceStatusFetching: true,
        stravaDeviceStatusFail: false
    };
};

const fetchStravaDeviceStatusSuccess = (state, action) => {
    return {
        ...state,
        stravaDeviceStatus: action.stravaDeviceStatus,
        stravaDeviceStatusFetching: false,
        stravaDeviceStatusFail: false
    };
};

const fetchStravaDeviceStatusFail = (state, action) => {
    return {
        ...state,
        stravaDeviceStatus: action.stravaDeviceStatus,
        stravaDeviceStatusFetching: false,
        stravaDeviceStatusFail: true
    };
};

// ======= Updating Handlers =======
const updateStravaAccessInfoUpdating = (state, action) => {
    return {
        ...state,
        stravaAccessInfoUpdating: true,
        stravaAccessInfoUpdateSucceed: false,
        stravaAccessInfoUpdateFail: false
    };
};

const updateStravaAccessInfoSuccess = (state, action) => {
    return {
        ...state,
        stravaAccessInfo: action.stravaAccessInfo,
        stravaAccessInfoUpdating: false,
        stravaAccessInfoUpdateSucceed: true,
        stravaAccessInfoUpdateFail: false
    };
};

const updateStravaAccessInfoFail = (state, action) => {
    return {
        ...state,
        stravaAccessInfo: action.stravaAccessInfo,
        stravaAccessInfoUpdating: false,
        stravaAccessInfoUpdateSucceed: false,
        stravaAccessInfoUpdateFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_STRAVA_ACCESS_FETCHING]: fetchStravaAccessInfoFetching,
    [FETCH_STRAVA_ACCESS_SUCCESS]: fetchStravaAccessInfoSuccess,
    [FETCH_STRAVA_ACCESS_FAIL]: fetchStravaAccessInfoFail,
    [FETCH_STRAVA_CONSUMER_DATA_FETCHING]: fetchStravaConsumerDataFetching,
    [FETCH_STRAVA_CONSUMER_DATA_SUCCESS]: fetchStravaConsumerDataSuccess,
    [FETCH_STRAVA_CONSUMER_DATA_FAIL]: fetchStravaConsumerDataFail,
    [FETCH_STRAVA_DEVICE_STATUS_FETCHING]: fetchStravaDeviceStatusFetching,
    [FETCH_STRAVA_DEVICE_STATUS_SUCCESS]: fetchStravaDeviceStatusSuccess,
    [FETCH_STRAVA_DEVICE_STATUS_FAIL]: fetchStravaDeviceStatusFail,
    [UPDATE_STRAVA_ACCESS_UPDATING]: updateStravaAccessInfoUpdating,
    [UPDATE_STRAVA_ACCESS_SUCCESS]: updateStravaAccessInfoSuccess,
    [UPDATE_STRAVA_ACCESS_FAIL]: updateStravaAccessInfoFail
};

export default function strava(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======
export const getStravaAccessInfo = (state) => {
    return state.strava.stravaAccessInfo;
};

export const isStravaAccessInfoFetching = (state) => {
    return state.strava.stravaAccessInfoFetching;
};

export const didStravaAccessInfoFetchFail = (state) => {
    return state.strava.stravaAccessInfoFail;
};

export const getStravaConsumerData = (state) => {
    return state.strava.stravaConsumerData;
};

export const isStravaConsumerDataFetching = (state) => {
    return state.strava.stravaConsumerDataFetching;
};

export const didStravaConsumerDataFetchFail = (state) => {
    return state.strava.stravaConsumerDataFail;
};

export const getStravaDeviceStatus = (state) => {
    return state.strava.stravaDeviceStatus;
};

export const isStravaDeviceStatusFetching = (state) => {
    return state.strava.stravaDeviceStatusFetching;
};

export const didStravaDeviceStatusFetchFail = (state) => {
    return state.strava.stravaDeviceStatusFail;
};
